import {
  PropType,
  defineComponent,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  reactive,
} from 'vue'
import { currency } from '@/utils/currency'
import styles from './styles.module.scss'
import { OS } from '@/utils/device'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { useComponentStore } from '../../../nsh5/localStores/component'
import { getIndicatorSummary } from '../../../apis/map.api'
import { IndicatorItemModel } from './indicator'
import { formatDate } from '@/utils/time'
import { DigitFlip } from '@nio-pow/h5-components' // 使用新数字翻转组件
declare global {
  interface Window {
    soMapBasicInfo: any
  }
}
export default defineComponent({
  name: 'information-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
  },

  setup: () => {
    const componentStore = useComponentStore()
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const state: {
      basicInfo: { [key: string]: IndicatorItemModel }
    } = reactive({
      basicInfo: {},
    })
    let timer: any = null

    // 动态指标
    const DYNAMIC_INDICATOR_CODE_LIST = [
      'nio_service_so_service_sum', // 无忧服务总和
      'nio_service_value_add_service', // 增值服务
      'nio_service_pick_up_and_drop_off_service', // 取送车服务
      'nio_service_maintenance_service', // 维保服务
      'nio_service_mobile_service', // 移动服务
      'nio_service_transport_service', // 代步出行服务
      'nio_service_refresh_and_upgrade_service', // 焕新升级服务
      'nio_service_rescue_service', // 救援服务
    ]
    // 离线指标
    const STATIC_INDICATOR_CODE_LIST = [
      'nio_service_service_center_sum', // 服务中心总和
      'nio_service_electromechanical_station', // 机电工位
      'nio_service_accident_station', // 事故工位
      'nio_service_coverage_rate', // 服务中心覆盖率
    ]

    const getSoInformation = async () => {
      const res: any = await getIndicatorSummary([], 'nio_service_center_map')
      if (res && res.data) {
        state.basicInfo = res.data.indicator_map
        componentStore.setStatisticUpdateTimestamp()
      }
      // 获取动态指标
      DYNAMIC_INDICATOR_CODE_LIST.forEach((indicatorCode: string) => {
        const indicatorValue =
          res.data.indicator_map && res.data.indicator_map[indicatorCode]
            ? res.data.indicator_map[indicatorCode]['indicator_item_map']['region_code:000000'] ||
              {}
            : {}
        state.basicInfo[indicatorCode] = new IndicatorItemModel({ ...indicatorValue })
      })
      if (!state.basicInfo['nio_service_so_service_sum']?.indicatorValue) {
        state.basicInfo['nio_service_so_service_sum'].indicatorValue =
          Number(state.basicInfo['nio_service_value_add_service']?.indicatorValue || 0) +
          Number(state.basicInfo['nio_service_pick_up_and_drop_off_service']?.indicatorValue || 0) +
          Number(state.basicInfo['nio_service_maintenance_service']?.indicatorValue || 0) +
          Number(state.basicInfo['nio_service_mobile_service']?.indicatorValue || 0) +
          Number(state.basicInfo['nio_service_transport_service']?.indicatorValue || 0) +
          Number(state.basicInfo['nio_service_refresh_and_upgrade_service']?.indicatorValue || 0) +
          Number(state.basicInfo['nio_service_rescue_service']?.indicatorValue || 0)
      }
      // 获取离线指标
      STATIC_INDICATOR_CODE_LIST.forEach((indicatorCode: string) => {
        const indicatorValue =
          res.data.indicator_map && res.data.indicator_map[indicatorCode]
            ? res.data.indicator_map[indicatorCode]['indicator_item_map']['region_code:000000'] ||
              {}
            : {}
        state.basicInfo[indicatorCode] = new IndicatorItemModel({ ...indicatorValue })
      })
    }
    document.onvisibilitychange = () => {
      if (document.visibilityState === 'visible') {
        console.log('====================================');
        console.log('document.visibilityState === visible, soInformation');
        console.log('====================================');
        componentStore.setStatisticUpdateTimestamp(false);
      }
    };

    const onReceiveIndicatorMessage = (messageObj: any) => {
      let changed = false
      const indicatorCode = messageObj.indicator_code
      if (indicatorCode && DYNAMIC_INDICATOR_CODE_LIST.includes(indicatorCode)) {
        changed = true
        state.basicInfo[indicatorCode].indicatorValue =
          messageObj['indicator_item_map']['region_code:000000']['indicator_value']
      }
      if (changed) {
        timer && clearTimeout(timer)
        timer = setTimeout(() => {
          state.basicInfo['nio_service_so_service_sum'].indicatorValue =
            Number(state.basicInfo['nio_service_value_add_service']?.indicatorValue || 0) +
            Number(
              state.basicInfo['nio_service_pick_up_and_drop_off_service']?.indicatorValue || 0
            ) +
            Number(state.basicInfo['nio_service_maintenance_service']?.indicatorValue || 0) +
            Number(state.basicInfo['nio_service_mobile_service']?.indicatorValue || 0) +
            Number(state.basicInfo['nio_service_transport_service']?.indicatorValue || 0) +
            Number(
              state.basicInfo['nio_service_refresh_and_upgrade_service']?.indicatorValue || 0
            ) +
            Number(state.basicInfo['nio_service_rescue_service']?.indicatorValue || 0)
        }, 300)
      }
    }

    componentStore.bus.on('onReceiveIndicatorMessage', onReceiveIndicatorMessage)

    /**
     * 刷新全国看板数据
     */
    const refreshInformation = async () => {
      getSoInformation()
    }

    /**
     * 概览点击阻止冒泡
     */
    const stopPropagation = (e: any) => {
      e.stopPropagation()
    }

    onBeforeMount(() => {
      if (window.soMapBasicInfo) {
        state.basicInfo = window.soMapBasicInfo
      }
      refreshInformation()
    })

    let dataRefresher: any = null
    onMounted(async () => {
      dataRefresher && clearInterval(dataRefresher)
      dataRefresher = setInterval(async () => {
        refreshInformation()
      }, (componentsConfig?.refresh?.properties?.refresh_interval || 3) * 60 * 1000) // 6小时刷新下首页数据概览
    })

    onBeforeUnmount(() => {
      componentStore.clearStatisticUpdateTimer()
      clearInterval(dataRefresher)
    })

    onUnmounted(() => {
      window.soMapBasicInfo = state.basicInfo
      componentStore.bus.off('onReceiveIndicatorMessage')
    })

    const showEachLegend = (key: string) => {
      return componentsConfig?.filter?.properties?.items?.indexOf(key) > -1
    }
    return () => {
      return (
        <div
          id="information"
          class={[
            styles.information,
            styles.mapReady,
            OS.isAndroid ? styles.android : '',
            OS.isNioBrowser ? styles.isNioBrowser : '',
          ]}
          onClick={stopPropagation}
          onTouchend={stopPropagation}
        >
          <img
            class={styles.logo}
            src="https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/nioService.png"
            alt=""
          />
          {componentsConfig?.data_default?.show ? (
            <div class={styles.data}>
              <div class={styles.dataBox}>
                <div class={styles.realtime}>
                  <h6>无忧服务次数</h6>
                  <div class={styles.refresh_outer}>
                    <DigitFlip
                      num={state.basicInfo['nio_service_so_service_sum']?.indicatorValue || ''}
                    />
                    <span class={styles.unit}>次</span>
                  </div>
                </div>
                <div class={styles.infoDataArea}>
                  <div>
                    <div>
                      <h6>增值服务</h6>
                      <strong>
                        <DigitFlip
                          num={
                            state.basicInfo['nio_service_value_add_service']?.indicatorValue || ''
                          }
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div>
                      <h6>维保服务</h6>
                      <strong>
                        <DigitFlip
                          num={
                            state.basicInfo['nio_service_maintenance_service']?.indicatorValue || ''
                          }
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div>
                      <h6>代步出行服务</h6>
                      <strong>
                        <DigitFlip
                          num={
                            state.basicInfo['nio_service_transport_service']?.indicatorValue || ''
                          }
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div>
                      <h6>救援服务</h6>
                      <strong>
                        <DigitFlip
                          num={state.basicInfo['nio_service_rescue_service']?.indicatorValue || ''}
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div class={styles.bigStrong}>
                      <h6>服务中心数量</h6>
                      <strong>
                        {currency(
                          state.basicInfo['nio_service_service_center_sum']?.indicatorValue || ''
                        )}
                      </strong>
                      <span class={styles.unit}>个</span>
                    </div>
                    <div>
                      <h6>机电工位</h6>
                      <strong>
                        {currency(
                          state.basicInfo['nio_service_electromechanical_station']
                            ?.indicatorValue || ''
                        )}
                      </strong>
                      <span class={styles.unit}>个</span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <h6>取送车服务</h6>
                      <strong>
                        <DigitFlip
                          num={
                            state.basicInfo['nio_service_pick_up_and_drop_off_service']
                              ?.indicatorValue || ''
                          }
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div>
                      <h6>移动服务</h6>
                      <strong>
                        <DigitFlip
                          num={state.basicInfo['nio_service_mobile_service']?.indicatorValue || ''}
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div>
                      <h6>焕新升级服务</h6>
                      <strong>
                        <DigitFlip
                          num={
                            state.basicInfo['nio_service_refresh_and_upgrade_service']
                              ?.indicatorValue || ''
                          }
                        />
                      </strong>
                      <span class={styles.unit}>次</span>
                    </div>
                    <div class={styles.clearFloat}>
                      <h6></h6>
                      <strong></strong>
                    </div>
                    <div class={styles.bigStrong}>
                      <h6>服务中心覆盖率</h6>
                      <strong>
                        {state.basicInfo['nio_service_coverage_rate']?.indicatorValue ? (
                          <>
                            {Number(state.basicInfo['nio_service_coverage_rate']?.indicatorValue) *
                              100}
                          </>
                        ) : (
                          ''
                        )}
                      </strong>
                      <span class={styles.unit}>%</span>
                    </div>
                    <div>
                      <h6>事故工位</h6>
                      <strong>
                        {currency(
                          state.basicInfo['nio_service_accident_station']?.indicatorValue || ''
                        )}
                      </strong>
                      <span class={styles.unit}>个</span>
                    </div>
                  </div>
                </div>
                <div class={styles.updateTime}>
                  *截至
                  {componentStore.statisticUpdateTimeString}
                </div>
              </div>
            </div>
          ) : null}
          <div class={styles.mark}>
            {showEachLegend('service_center') && (
              <div>
                <i class={[styles.imgArea, styles.so]}></i>
                <div>服务中心</div>
              </div>
            )}
            {(showEachLegend('recharge') || showEachLegend('recharge|ps')) && (
              <div>
                <i class={[styles.imgArea, styles.swap]}></i>
                <div>换电站</div>
              </div>
            )}
            {(showEachLegend('recharge') || showEachLegend('recharge|cs')) && (
              <>
                <div>
                  <i class={[styles.imgArea, styles.station]}></i>
                  <div>充电站</div>
                </div>
                {componentsConfig.third_resource?.show ? (
                  <div>
                    <i class={[styles.imgArea, styles.third]}></i>
                    <div>第三方充电桩</div>
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      )
    }
  },
})
